import { RootState } from '../core'

export const selectedLocale = (state: RootState) => state.utils.locale
export const selectedHotelFilters = (state: RootState) => state.utils.hotelFilters
export const selectRecentlyVisitedPages = (state: RootState) => state.utils.recentlyVisitedPages
